var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-table',{ref:"table",attrs:{"headers":_vm.headers,"query":_vm.useProjectChangesQuery,"itemsGetter":_vm.itemsGetter,"totalCountGetter":_vm.totalCountGetter,"defaultFilter":Object.assign({}, {project: { Id: { eq: _vm.project.Id } }},
    (_vm.project.projectChange
      ? {
          Id: {
            neq: _vm.project.projectChange.Id,
          },
        }
      : {})),"tableTitle":"História projektu"},on:{"click:row":_vm.onRowClick},scopedSlots:_vm._u([{key:"UpdatedAt",fn:function(ref){
  var item = ref.item;
return [_vm._v(_vm._s(_vm._f("luxon")(item.UpdatedAt,"ff"))+" ")]}},{key:"modifiedBy",fn:function(ref){
  var item = ref.item;
return [_vm._v(" "+_vm._s(item.modifiedBy ? item.modifiedBy.Username : "Vymazaný")+" ")]}},{key:"State",fn:function(ref){
  var item = ref.item;
return [_vm._v(" "+_vm._s(item.State)+" ")]}},{key:"remove-dialog",fn:function(ref){
  var item = ref.item;
return [_c('delete-project-change-dialog',{attrs:{"projectChange":item},on:{"removed":_vm.reloadTable}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }